/**
 * Check if the given color is transparent.
 */
function isColorTransparent(color: string) {
    if (color === 'transparent' || color === 'rgba(0, 0, 0, 0)') {
        return true;
    }
    const alpha = parseFloat(color.slice(-1 * (color.indexOf('a') + 1), -1));
    return alpha < 1;
}

/**
 * Get the first non-transparent color from the given list of colors.
 */
const getFirstNonTransparentColor = (colors: string[]) => {
    return colors.find((color) => !isColorTransparent(color));
};

/**
 * Compute the color of the wave effect based on the target element's color.
 *
 * If `colorProp` is provided, the color will be computed based on the value of the specified property.
 * Otherwise, the color will be computed based on the target element's `background-color`, `border-color`, and `color`.
 * The first non-transparent color will be used.
 *
 * @param element The target element
 * @param colorProp The CSS property to compute the color from
 */
export const computeWaveColor = (
    element: HTMLElement,
    colorProp?: 'background-color' | 'border-color' | 'color'
) => {
    if (colorProp) {
        return getComputedStyle(element).getPropertyValue(colorProp);
    }
    const compStyles = getComputedStyle(element);
    const targetBgColor = compStyles.getPropertyValue('background-color');
    const targetBorderColor = compStyles.getPropertyValue('border-color');
    const targetColor = compStyles.getPropertyValue('color');
    return (
        getFirstNonTransparentColor([targetBgColor, targetBorderColor, targetColor]) ??
        'currentColor'
    );
};
